/* Colors */
window.hexToRgb = function(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}

window.brightnessByColor = function (color) {
  var color = "" + color, isHEX = color.indexOf("#") == 0, isRGB = color.indexOf("rgb") == 0
  if (isHEX) {
    const hasFullSpec = color.length == 7
    var m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g)
    if (m) var r = parseInt(m[0] + (hasFullSpec ? '' : m[0]), 16), g = parseInt(m[1] + (hasFullSpec ? '' : m[1]), 16), b = parseInt(m[2] + (hasFullSpec ? '' : m[2]), 16)
  }
  if (isRGB) {
    var m = color.match(/(\d+){3}/g)
    if (m) var r = m[0], g = m[1], b = m[2]
  }
  if (typeof r != "undefined") return ((r*299)+(g*587)+(b*114))/1000
}

window.randomizeColors = function() {
  let colorable = require('colorable'), colorsFound = false
  while (!colorsFound) {
    let colorCombinations = colorable({
      a: '#' + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0'),
      b: '#' + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0'),
      c: '#' + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0'),
      d: '#' + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0'),
      e: '#' + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0'),
      f: '#' + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0'),
    }, {
      compact: true,
      threshold: 4.5,
    })
    if (colorCombinations[0].combinations.length > 0) {
      colorsFound = true
      let rgbA = hexToRgb(colorCombinations[0].hex),
      rgbB = hexToRgb(colorCombinations[0].combinations[0].hex),
      rgbG = hexToRgb('#EFEFEF'),
      brightnessA = brightnessByColor(colorCombinations[0].hex),
      brightnessB = brightnessByColor(colorCombinations[0].combinations[0].hex)
      if (brightnessA > brightnessB) {
        let originalA = rgbA
        rgbA = rgbB
        rgbB = originalA
      }
      $('#feFuncR_tone').attr('tableValues', (rgbA.r / 255) + ' ' + rgbB.r / 255)
      $('#feFuncG_tone').attr('tableValues', (rgbA.g / 255) + ' ' + rgbB.g / 255)
      $('#feFuncB_tone').attr('tableValues', (rgbA.b / 255) + ' ' + rgbB.b / 255)
      $('#feFuncR_gray').attr('tableValues', (rgbA.r / 255) + ' ' + rgbG.r / 255)
      $('#feFuncG_gray').attr('tableValues', (rgbA.g / 255) + ' ' + rgbG.g / 255)
      $('#feFuncB_gray').attr('tableValues', (rgbA.b / 255) + ' ' + rgbG.b / 255)
      document.querySelector(":root").style.setProperty('--color-a', colorCombinations[0].hex)
      document.querySelector(":root").style.setProperty('--color-b', colorCombinations[0].combinations[0].hex)
    }
  }
}
